import { ROUTES } from 'app/core/router/paths';

/**
 * @description 流程步驟代碼
 */
export enum ProcessStepCodesEnum {
  /** 修改保期 (Step-1) */
  PolicyInfo = '1',
  /** 確認資料 (Step-2-1) */
  ConfirmInfo = '2-1',
  /** 確認資料-opt (Step-2-2) */
  ConfirmInfoOTPAuth = '2-2',
  /** 線上繳費/帳戶轉帳 (Step-3) */
  PaymentTransfer = '3',
  /** 線上繳費/信用卡 (Step-3) */
  PaymentCreditCard = '3',
  /** 修改完成 (Step-4) */
  Result = '4'
}

/**
 * @description 流程步驟文字
 */
export enum ProcessStepTextEnum {
  /** 修改保期 (Step-1) */
  PolicyInfo = '修改保期',
  /** 確認資料 (Step-2) */
  ConfirmInfo = '確認資料',
  /** 線上繳費 (Step-3) */
  Payment = '線上繳費',
  /** 修改完成 (Step-4) */
  Result = '修改完成'
}

/**
 * @description 流程路由對應步驟代碼
 */
export const ProcessRouteMatchesStep: Readonly<Record<string, ProcessStepCodesEnum>> = {
  /** 確認資料 (Step-1) */
  [ROUTES.SERVICE__QUERY_POLICY__MODIFY__POLICY_INFO]: ProcessStepCodesEnum.PolicyInfo,
  /** 確認資料 (Step-2-1) */
  [ROUTES.SERVICE__QUERY_POLICY__MODIFY__CONFIRM_INFO]: ProcessStepCodesEnum.ConfirmInfo,
  /** 確認資料 (Step-2-2) */
  [ROUTES.SERVICE__QUERY_POLICY__MODIFY__CONFIRM_INFO__OTP_AUTH]: ProcessStepCodesEnum.ConfirmInfoOTPAuth,
  /** 線上繳費/帳戶轉帳 (Step-3) */
  [ROUTES.SERVICE__QUERY_POLICY__MODIFY__PAYMENT__TRANSFER]: ProcessStepCodesEnum.PaymentTransfer,
  /** 線上繳費/信用卡 (Step-3) */
  [ROUTES.SERVICE__QUERY_POLICY__MODIFY__PAYMENT__CREDIT_CARD]: ProcessStepCodesEnum.PaymentCreditCard,
  /** 修改完成 (Step-4) */
  [ROUTES.SERVICE__QUERY_POLICY__MODIFY__RESULT]: ProcessStepCodesEnum.Result
};

/**
 * @description 流程步驟代碼對應路由
 */
export const ProcessStepMatchesRoute: Readonly<Record<ProcessStepCodesEnum, string>> = {
  /** 確認資料 (Step-1) */
  [ProcessStepCodesEnum.PolicyInfo]: ROUTES.SERVICE__QUERY_POLICY__MODIFY__POLICY_INFO,
  /** 確認資料 (Step-2-1) */
  [ProcessStepCodesEnum.ConfirmInfo]: ROUTES.SERVICE__QUERY_POLICY__MODIFY__CONFIRM_INFO,
  /** 確認資料 (Step-2-2) */
  [ProcessStepCodesEnum.ConfirmInfoOTPAuth]: ROUTES.SERVICE__QUERY_POLICY__MODIFY__CONFIRM_INFO__OTP_AUTH,
  /** 線上繳費/帳戶轉帳 (Step-3) */
  [ProcessStepCodesEnum.PaymentTransfer]: ROUTES.SERVICE__QUERY_POLICY__MODIFY__PAYMENT__TRANSFER,
  /** 線上繳費/信用卡 (Step-3) */
  [ProcessStepCodesEnum.PaymentCreditCard]: ROUTES.SERVICE__QUERY_POLICY__MODIFY__PAYMENT__CREDIT_CARD,
  /** 修改完成 (Step-4) */
  [ProcessStepCodesEnum.Result]: ROUTES.SERVICE__QUERY_POLICY__MODIFY__RESULT
};
